import { useCanReviewOtherUsersSessionList } from '@/hooks/useCanReviewOtherUsersSessionList';
import { useCombinedQueriesTeamGeneralInfo } from '@heidi/workspace/data';

/**
 * Whether the current user can view other members' sessions: the team's
 * session-sharing allowlist (`useCanReviewOtherUsersSessionList`) with a
 * support-role bypass.
 *
 * Single source of truth for the "can view others" rule so it can't drift
 * between the session-scope tabs (`useVisibleSessionScopes`) and the delegation
 * clinician selector (`useShowClinicianSelector`).
 */
export function useCanViewOthersSessions(): boolean {
  const { isSupportRole } = useCombinedQueriesTeamGeneralInfo();
  const hasAllowlistedAccess = useCanReviewOtherUsersSessionList();

  return isSupportRole || hasAllowlistedAccess;
}
